import { render, staticRenderFns } from "./v-table-searchable2.vue?vue&type=template&id=784e325c&"
import script from "./v-table-searchable2.vue?vue&type=script&lang=js&"
export * from "./v-table-searchable2.vue?vue&type=script&lang=js&"
import style0 from "./v-table-searchable2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports